import React from 'react'

import { Typography } from '@material-ui/core'
import { HeaderTitle } from './styles'

export default function AboutComponent() {

    const aspect = 240 / 150

    const width = 800 > (window.innerWidth - 40) ? (window.innerWidth - 40) : 800

    return <div style={{ marginLeft: 20, marginTop: 20, marginRight: 20 }}>
        <HeaderTitle >
            About Tadpole
        </HeaderTitle>

        <div style={{ maxWidth: 800 }}>
            <Typography style={{ marginTop: 10 }}>
                Tadpole is a tool that helps gather requirements. It takes variables from the user as input, and outputs a table of all the possible combinations of those variables. This table can then be used to specify the requirements of a system.
            </Typography>

            <Typography style={{ marginTop: 10 }}>
                Tadpole was created after Mark found himself creating tables of combinations to specify the complex security model for <a href="https://waldologs.com/">Waldo</a>.
            </Typography>

            <Typography style={{ marginTop: 10 }}>
                Checkout <a href="https://lauriumlabs.com/blog/tadpole">our blog post on Tadpole</a>.
            </Typography>

            <Typography style={{ marginTop: 10, fontWeight: 600 }}>Video Demo</Typography>

            <iframe
                src="https://player.vimeo.com/video/533237999?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Tadpole.mp4"
                width={width}
                height={width / aspect}
            ></iframe>
        </div>
    </div>
}